
import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const ProcessingIndicator = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  const messages = [
    "✨ Just a moment while I gather your thoughts...",
    "🧠 Thinking really hard about this one...",
    "🔮 Consulting the digital crystal ball...",
    "📚 Flipping through your memory book...",
    "🤹‍♀️ Juggling data and dreams...",
    "🚀 Boosting brainpower, please hold...",
    "🎩 Pulling insights out of a top hat...",
    "☕ Brewing your morning smarts...",
    "🧘‍♀️ Channeling clarity...",
    "🌈 Painting a prettier picture of your day...",
    "🔧 Just tightening a few data bolts...",
    "📚 Flipping through your memory pages...",
    "🌟 Your digital assistant is on it!",
    "🤖 Thinking faster than a caffeinated robot...",
    "🧠 Dusting off some neural pathways...",
    "📅 Cross-referencing calendars and caffeine levels...",
    "💬 Whispering with your data...",
    "📡 Searching the cloud for answers (the digital kind)...",
    "🎯 Lining up insights like a boss...",
    "🌈 Building your day, one pixel at a time...",
    "🕵️‍♀️ Snooping around your schedule (in the nicest way)...",
    "📦 Wrapping up your results with digital tape...",
    "🧃 Rehydrating the AI... hang tight!",
    "🎮 Loading the next level of productivity...",
    "🌀 Spinning up some clever thoughts for you...",
    "🧭 Navigating your data jungle...",
    "🚀 Prepping for launch… any second now!",
    "📀 Burning the midnight silicon...",
    "🪄 Giving your to-dos a makeover...",
    "🎉 Almost there—your day is about to get easier!"
  ];

  useEffect(() => {
    const messageTimer = setInterval(() => {
      setMessageIndex(() => Math.floor(Math.random() * messages.length));
    }, 4000); // Change message every 4 seconds

    return () => clearInterval(messageTimer);
  }, [messages.length]);

  return (
    <div className="flex items-center space-x-2 sm:space-x-3 px-3 sm:px-6 py-3 sm:py-4 bg-muted text-muted-foreground rounded-lg w-full max-w-none">
      <Loader2 className="w-4 h-4 animate-spin flex-shrink-0" />
      <span className="text-xs sm:text-sm flex-1 min-w-0">
        {messages[messageIndex]}
      </span>
    </div>
  );
};

export default ProcessingIndicator;
